export default {
  checkNumber: '/admission-service/admission/setting/checkNumber',
  editSettingDisableFlag: '/admission-service/admission/setting/editDisableFlag',
  saveBaseTour: '/admission-service/admission/setting/saveBaseTour',
  editBaseTour: '/admission-service/admission/setting/editBaseTour',
  selectBaseTourByPage: '/admission-service/admission/setting/selectBaseTourByPage',
  selectBaseTourGradeId: '/admission-service/admission/setting/selectBaseTourGradeId',
  selectTourByGradeId: '/admission-service/admission/setting/selectTourByGradeId',
  saveBaseExam: '/admission-service/admission/setting/saveBaseExam',
  editBaseExam: '/admission-service/admission/setting/editBaseExam',
  selectBaseExamByPage: '/admission-service/admission/setting/selectBaseExamByPage',
  selectBaseExamByGradeId: '/admission-service/admission/setting/selectBaseExamByGradeId',
  selectExamByCurrent: '/admission-service/admission/setting/selectExamByCurrent',
  saveBasePickup: '/admission-service/admission/setting/saveBasePickup',
  selectBasePickup: '/admission-service/admission/setting/selectBasePickup',
  saveDictionary: '/admission-service/admission/setting/saveDictionary',
  selectDictionaryByCode: '/admission-service/admission/setting/selectDictionaryByCode',
  selectDictionarys: '/admission-service/admission/setting/selectDictionarys'
}



// WEBPACK FOOTER //
// ./src/config/basedata/setting/index.js